import { createContext } from "react";

import type { RelatedDetailContextValue } from "./types";

/** 跨实体详情导航 Context（Provider / Hook 共用） */
export const RelatedDetailContext = createContext<RelatedDetailContextValue | null>(null);
